import PDRObraAvaliacao from '@/shared/http/repositories/pci/pdrobraavaliacao'
import { loading, toast } from '@/shared/utils/UIHelper'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import { AgGridVue } from 'ag-grid-vue'
import moment from 'moment'
import VueHtml2pdf from 'vue-html2pdf'
import gridMixin from '../mixins/gridMixin'

export default {
  name: 'PDRValuesReport',
  mixins: [gridMixin, CompanyMixin, PermissionMixin, AccountMixin],
  data () {
    return {
      pdrvaluesOrigin: [],
      pdrvalues: [],
      // pdrvaluesPdf: [],
      columnDefs: null,
      workTeamViewEnabled: false,
      filterPlaceholder: '',
      // filterValue: '',
      gridOptions2: {
        getRowStyle: params => {
          if (params.data.funcao_nivel === 1) {
            return { fontWeight: 'bold' }
          }
          return null
        }
      },
      totalRows: 0,
      totalValueRows: 0.0,
      totalValuePaidRows: 0.0,
      showModalFilter: true,
      modalFilterData: {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        employee: '',
        option: '1'
      }
    }
  },
  components: {
    AgGridVue,
    VueHtml2pdf
  },
  // watch: {
  //   filterValue (newValue, oldValue) {
  //     this.onFilterValueChange(newValue)
  //   }
  // },
  mounted () {
    this.onLoad()
  },
  methods: {
    filter () {
      this.showModalFilter = false
      this.getPDRValues()
    },
    onLoad () {
      this.columnDefs = [
        {
          headerName: 'Obra',
          maxWidth: 100,
          field: 'referencia',
          type: 'textColumn',
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: 'ID Site',
          maxWidth: 150,
          field: 'id_site',
          type: 'textColumn',
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: 'Contrato',
          minWidth: 200,
          field: 'contrato',
          type: 'textColumn',
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: 'Função',
          minWidth: 200,
          field: 'funcao',
          type: 'textColumn',
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: 'Cód. Funcionário',
          maxWidth: 80,
          field: 'funcionario_codigo',
          type: 'textColumn',
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: 'Funcionário',
          minWidth: 200,
          field: 'funcionario',
          type: 'textColumn',
          menuTabs: ['filterMenuTab']
        },
        {
          headerName: 'Data Recebimento',
          maxWidth: 160,
          field: 'data_recebimento',
          type: 'dateColumn',
          suppressColumnsToolPanel: true,
          suppressMenu: true,
          filter: false
        },
        {
          headerName: 'Valor Bruto',
          maxWidth: 115,
          field: 'valor_bruto',
          type: 'numberColumn',
          suppressColumnsToolPanel: true,
          suppressMenu: true,
          filter: false
        },
        {
          headerName: 'Nota',
          maxWidth: 70,
          field: 'nota',
          type: 'numberColumn',
          suppressColumnsToolPanel: true,
          suppressMenu: true,
          filter: false
        },
        {
          headerName: 'Valor Recebido',
          maxWidth: 140,
          field: 'valor_recebido',
          type: 'numberColumn',
          suppressColumnsToolPanel: true,
          suppressMenu: true,
          filter: false
        },
        {
          headerName: 'Observação',
          minWidth: 100,
          field: 'observacao',
          type: 'textColumn',
          suppressColumnsToolPanel: true,
          suppressMenu: true,
          filter: false
        }
      ]
    },
    calculateValues () {
      let totalRows = 0
      let totalValueRows = 0.0
      let totalValuePaidRows = 0.0
      this.gridOptions2.api.rowModel.forEachNodeAfterFilter(row => {
        totalRows++
        totalValueRows += row.data.valor_bruto
        totalValuePaidRows += row.data.valor_recebido
      })
      this.totalRows = totalRows
      this.totalValueRows = totalValueRows.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      this.totalValuePaidRows = totalValuePaidRows.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    },
    getPDRValues () {
      loading.push()
      PDRObraAvaliacao.GetPDRValues(this.modalFilterData.startDate, this.modalFilterData.endDate, this.modalFilterData.employee, this.company.id, this.modalFilterData.option)
        .then(response => {
          if (response.data.code > 0) {
            let pdrvalues = response.data.data.map(p => {
              return {
                referencia: p.obraReferencia,
                id_site: p.idSite,
                contrato: p.contrato,
                funcao: p.funcao,
                funcao_nivel: p.funcaoNivel,
                funcionario: p.funcionarioNome,
                funcionario_codigo: p.funcionarioCodigo,
                data_recebimento: p.dataRecebimento,
                valor_bruto: p.valorBruto,
                nota: p.nota,
                valor_recebido: p.valorRecebido,
                observacao: p.observacao
              }
            })

            // this.filterValue = ''
            this.pdrvaluesOrigin = pdrvalues
            this.pdrvalues = pdrvalues
            this.totalRows = pdrvalues.length

            // this.totalValueRows = pdrvalues.reduce((t, i) => t + i.valor_bruto, 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
            // this.totalValuePaidRows = pdrvalues.reduce((t, i) => t + i.valor_recebido, 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})

            this.$nextTick(() => {
              this.calculateValues()
              setTimeout(() => this.gridOptions2.api.sizeColumnsToFit(), 200)
            })
          }
        })
        .catch((e) => {
          console.log(e)
          toast.error(this.$lang.Common.CouldNotLoadRegister)
        })
        .finally(() => loading.close())
    },
    getContextMenuItems (params) {
      if (!params.node) return []
      return [
        {
          name: this.$lang.PCI.Spreadsheet.ExcelExport,
          action: () => { this.exportExcel(params) },
          icon: '<i class="far fa-file-excel"></i>'
        }
      ]
    },
    exportExcel (params) {
      const content = [{
        cells: params.columnApi.getAllDisplayedColumns().map(col => {
          let value = this.gridOptions2.api.rowModel.getRow(0).data[col.colId]
          let style = 'rowCount'

          return {
            styleId: style,
            data: {
              value: value,
              type: 'Number'
            }
          }
        })
      }]
      const excelParams = {
        appendContent: content,
        processCellCallback (params) {
          return params.value
        }
      }

      this.gridOptions2.api.exportDataAsExcel(excelParams)
    },
    // workTeamView () {
    //   this.workTeamViewEnabled = !this.workTeamViewEnabled

    //   if (this.workTeamViewEnabled) {
    //     this.filterPlaceholder = this.$lang.PCI.PCIReports.PDRValues.CodeNameCoordPlaceholder
    //   } else {
    //     this.filterPlaceholder = this.$lang.PCI.PCIReports.PDRValues.CodeNamePlaceholder
    //   }

    //   this.onFilterValueChange(this.filterValue)
    // },
    // onFilterValueChange (value) {
    //   if (value === null || value === undefined || value.length === 0 || value.trim() === '') {
    //     this.pdrvalues = this.pdrvaluesOrigin
    //     this.totalRows = this.pdrvaluesOrigin.length
    //     this.totalValueRows = this.pdrvaluesOrigin.reduce((t, i) => t + i.valor_bruto, 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    //     this.totalValuePaidRows = this.pdrvaluesOrigin.reduce((t, i) => t + i.valor_recebido, 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    //     return
    //   }

    //   const valuesLower = value.toLowerCase()

    //   if (this.workTeamViewEnabled) {
    //     const workRefs = this.pdrvaluesOrigin.filter(d =>
    //       (d.funcionario.toLowerCase().includes(valuesLower) || d.funcionario_codigo.toString().includes(valuesLower)) &&
    //       d.funcao_nivel === 1)
    //       .map(d => d.referencia)
    //     const result = this.pdrvaluesOrigin.filter(d =>
    //       workRefs.includes(d.referencia))
    //     this.pdrvalues = result
    //     this.totalRows = result.length
    //     this.totalValueRows = result.reduce((t, i) => t + i.valor_bruto, 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    //     this.totalValuePaidRows = result.reduce((t, i) => t + i.valor_recebido, 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    //   } else {
    //     const result = this.pdrvaluesOrigin.filter(d =>
    //       (d.funcionario.toLowerCase().includes(valuesLower) || d.funcionario_codigo.toString().includes(valuesLower)))
    //     this.pdrvalues = result
    //     this.totalRows = result.length
    //     this.totalValueRows = result.reduce((t, i) => t + i.valor_bruto, 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    //     this.totalValuePaidRows = result.reduce((t, i) => t + i.valor_recebido, 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
    //   }
    // },
    /*
    generatePDF () {
      loading.push()
      this.filterToPdf()
      this.$refs.html2Pdf.generatePdf()
    },
    filterToPdf () {
      let work = ''
      let workteam = {}
      let pv = []
      let group = 1
      for (let i = 0; i < this.pdrvalues.length; i++) {
        if (this.pdrvalues[i].referencia !== work) {
          if (workteam && work !== '') {
            pv.push(workteam)
          }
          workteam = {}
          workteam.index = group
          workteam.obra = this.pdrvalues[i].referencia
          workteam.idSite = this.pdrvalues[i].id_site
          workteam.contrato = this.pdrvalues[i].contrato
          workteam.membros = []
          work = this.pdrvalues[i].referencia
          group++
        }
        workteam.membros.push({
          index: i,
          funcao: this.pdrvalues[i].funcao,
          codigo: this.pdrvalues[i].funcionario_codigo,
          nome: this.pdrvalues[i].funcionario,
          recebimento: moment(this.pdrvalues[i].data_recebimento).format('DD/MM/YYYY'),
          nota: this.pdrvalues[i].nota.toFixed(2),
          bruto: this.pdrvalues[i].valor_bruto.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}),
          recebido: this.pdrvalues[i].valor_recebido.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}),
          observacao: this.pdrvalues[i].observacao
        })
        if (this.pdrvalues.length === i + 1) {
          pv.push(workteam)
        }
      }

      this.pdrvaluesPdf = pv
    },
    async openPdf ({ html2pdf, options, pdfContent }) {
      const opt = {
        margin: 10,
        filename: 'Valores PDR.pdf',
        image: {
          type: 'jpeg', 'quality': 0.98
        },
        enableLinks: false,
        html2canvas: {
          scale: 2,
          useCORS: true
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait'
        }
      }
      await html2pdf().set(opt).from(pdfContent).toPdf().get('pdf')// .save()
      loading.close()
    },
    onProgress (event) {
      console.log(`Processed: ${event} / 100`)
      if (event === 100 || event === '100') { loading.close() }
    },
    */
    onFilterChanged (params) {
      this.calculateValues()
    },
    onGridReady (params) {
      // Set global grid helpers with his apis
    },
    printReport () {
      const data = this.gridOptions2.rowData
      const works = [...new Set(data.map(d => d.referencia))]

      const HEADER_HEIGHT = 26.4
      const LINE_HEIGHT = 31.0
      const PAGE_DATA_HEIGHT = 907.0

      const PAGES = Math.ceil(((works.length * HEADER_HEIGHT) + (data.length * LINE_HEIGHT)) / PAGE_DATA_HEIGHT)
      const DATE = this.moment().format('DD/MM/YYYY HH:mm:ss')

      let pageSize = 0
      let pageData = ''
      let docPagesData = ''
      let pageIdx = 1

      for (let i = 0; i < works.length; i++) {
        let workData = data.filter(d => d.referencia === works[i])
        pageSize += HEADER_HEIGHT

        let employeesData = ''
        for (let y = 0; y < workData.length; y++) {
          if (pageSize + LINE_HEIGHT >= PAGE_DATA_HEIGHT) {
            pageData += this.createReportWorkGroup(workData, employeesData)
            docPagesData += this.createReportPage(pageData, { usuario: this.account.nome, data: DATE, pagina: pageIdx, paginas: PAGES })
            pageSize = HEADER_HEIGHT
            pageData = ''
            employeesData = ''
            pageIdx++
          }

          employeesData += this.createReportWorkEmployee(workData[y])
          pageSize += LINE_HEIGHT
        }

        if (pageSize + LINE_HEIGHT >= PAGE_DATA_HEIGHT || i + 1 === works.length) {
          pageData += this.createReportWorkGroup(workData, employeesData)
          docPagesData += this.createReportPage(pageData, { usuario: this.account.nome, data: DATE, pagina: pageIdx, paginas: PAGES })
          pageSize = 0
          pageData = ''
          employeesData = ''
          pageIdx++
        } else {
          pageData += this.createReportWorkGroup(workData, employeesData)
        }
      }

      const report = this.createReportHtml(docPagesData).replaceAll('##PG_TOTAL##', pageIdx - 1)
      const newTab = window.open()
      newTab.document.open()
      newTab.document.write(report)
      newTab.document.close()
    },
    createReportHtml (content) {
      return `
      <html lang="pt-BR">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Valores PDR</title>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
      </head>
      <body style="background-color:gray;">
        <button class="d-print-none" style="position: fixed; margin: 1rem;" onclick="window.print()">Imprimir</button>

        <style>
          table, tr, td { padding:0px !important; }
          p { margin: 1mm !IMPORTANT; }
          .noborder { border: none !important; }
          .negrito { font-weight: bold; }
          .fonte-p { font-size: small; }
          .titulo { text-align: center; font-weight: bold; }
          .subtitulo { text-align: center; font-weight: bold; background-color:#ddd !important;font-size: small; }
          .subli > div {border-bottom: 1px lightGray solid}
          .br { margin-bottom: 3mm !important; }
        </style>

        ${content}

        </body>
      </html>
      `
    },
    createReportPage (content, footer) {
      return `
      <div class="d-print-none" style="height:0.5cm;">&nbsp;</div>
      <div style="width: 21cm; height: 29.7cm; margin: auto; background-color:white;">
      <table>
        <tr class="d-print-none"><td colspan="3" style="height:1cm;"></td></tr>
        <tr>
          <td class="d-print-none" style="width:1cm;"></td>
          <td style="height:28.7cm;vertical-align:top;">

            <div class="">
              <table class="table table-bordered">
                <tr>
                  <td rowspan="2" style="width:10%;text-align: center;padding: 1mm !important;">
                    <img src="/static/img/1Q.png" width="50" height="50" title="logo1Q" />
                  </td>
                  <td colspan="2" class="titulo">PLANEJAMENTO</td>
                  <td rowspan="2" style="width:25%;padding: 1mm !important;text-align: center;vertical-align: middle;">
                    <img src="/static/img/1.png" width="150" height="25" title="logo1" />
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="subtitulo">RESUMO DE VALORES - PDR</td>
                </tr>
                <tr class="fonte-p">
                  <td colspan="2" style="width:50%">
                  <p>Período:
                    <span class="negrito">
                      ${this.moment(this.modalFilterData.startDate).format('DD/MM/YYYY')}
                      até
                      ${this.moment(this.modalFilterData.endDate).format('DD/MM/YYYY')}
                    </span></p>
                  <p>Empresa: <span class="negrito"> ${this.company.nome} </span></p>
                  </td>
                  <td colspan="2">
                  <p>${this.modalFilterData.option === '1' ? 'Funcionário' : 'Coordenador'}: <span class="negrito"> ${this.modalFilterData.employee} </span></p>
                  </td>
                </tr>
              </table>

              ${content}

            </div>
          </td>
          <td class="d-print-none" style="width:1cm;"></td>
        </tr>
        <tr style="background-color:white;">
          <td class="d-print-none" style="width:1cm;"></td>
          <td style="height:1cm;">
            <div class="row" style="font-size:x-small;">
              <div class="col-4" style="width:6.5cm;">Impresso por: ${footer.usuario}</div>
              <div class="col-4" style="width:6.5cm;text-align:center">Em: ${footer.data}</div>
              <div class="col-4" style="width:6.5cm;text-align:right">Página ${footer.pagina}/##PG_TOTAL##</div>
            </div>
          </td>
          <td class="d-print-none" style="width:1cm;"></td>
        </tr>
        <tr class="d-print-none" style="background-color:white;"><td colspan="3" style="height:1cm;"></td></tr>
      </table>
    </div>
    <div class="d-print-none" style="height:2.5cm;">&nbsp;</div>
      `
    },
    createReportWorkGroup (workData, employeesData) {
      return `
        <div class="row br">
          <div class="row col-12" style="font-weight:bold; font-size:x-small;padding-left: 6mm;">
            OBRA: ${workData[0].referencia} &nbsp;&nbsp;|&nbsp;&nbsp;
            ID SITE: ${workData[0].id_site} &nbsp;&nbsp;|&nbsp;&nbsp;
            CONTRATO: ${workData[0].contrato}
          </div>

          ${employeesData}

        </div>
      `
    },
    createReportWorkEmployee (workMember) {
      return `
      <div class="row col-12" style="font-size: x-small;">
        <div class="col-8" style="text-wrap: nowrap;">
          ${workMember.funcionario_codigo} - ${workMember.funcionario} &nbsp;&nbsp;::&nbsp;&nbsp;
          ${workMember.funcao}
        </div>
        <div class="col-1">Data</div>
        <div class="col-1">Bruto</div>
        <div class="col-1">Nota</div>
        <div class="col-1">Receb</div>
      </div>
      <div class="row col-12 subli" style="font-size: x-small;">
        <div class="col-8">Obs.: ${(workMember.observacao == null ? '' : workMember.observacao)}</div>
        <div class="col-1">${this.moment(workMember.data_recebimento).format('DD/MM/YYYY')}</div>
        <div class="col-1">R$&nbsp;${workMember.valor_bruto.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</div>
        <div class="col-1">${workMember.nota.toFixed(2)}</div>
        <div class="col-1">R$&nbsp;${workMember.valor_recebido.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}</div>
      </div>
      `
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/reports/PDRValuesReport.js